"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidPaste;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

function isValidPaste(clipboardContent) {
  (0, _invariant.default)(typeof clipboardContent === 'string', "Expected 'clipboardContent' to be a string of HTML, received " + (0, _typeof2.default)(clipboardContent));
  (0, _invariant.default)(clipboardContent.length > 0, 'Expected clipboardContent to have content, received empty string');
}

module.exports = exports.default;